<template>

<div class="consumer">
    <div class="tip">
        <i class="el-icon-warning"></i>	{{textTip}}
    </div>
    <div class="consumer_body">
        <el-table ref="table" :data="tableData" stripe @select-all="handleSelectAll" @select="selectARow" :row-class-name="tableRowClassName">
            <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="交易时间" prop="createTime" width="150px" show-overflow-tooltip></el-table-column>
            <el-table-column label="项目" prop="orderNumber" width="200px" show-overflow-tooltip></el-table-column>
            <el-table-column label="开票状态" width="120px" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.row.billStatus != 1 ? '未开票' : '已开票' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="金额" prop="money" show-overflow-tooltip></el-table-column>
            <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination v-if="total/pageSize>1" :current-page.sync="pageNo"  :page-sizes="[5,10,15,50,100,1000]" :page-size="pageSize" style="text-align: left;margin-top: 20px;"
                background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
    </div>
    <div class="consumer_total">
        已选择 <span class="opera_active">{{multipleSelection.length}}</span> 条项目， 金额 <span class="opera_active">{{totalMoney}}</span> 元
    </div>
    <div class="right_align">
        <el-button class="warning" type="warning" @click="sure">确认</el-button>
        <el-button class="warning" @click="cancle">取消</el-button>
        <p style="margin-top:10px;">*订单开票后，您将不能申请该笔订单的退款</p>
        <p>*超过1年以上的开票金额请联系客服</p>
    </div>
</div>

</template>

<script>
import {selfRechargeList} from "@/api/finance.js"
import store from '@/store'
import { mapGetters } from "vuex";
export default {
    props:['rechargeType'],
    data(){
        return {
            tableData:[],
            pageNo:1,
            pageSize:5,
            total:0,
            tableLoading:false,
            multipleSelection: [],
            totalMoney:0,
            agentId : store.getters.agentId,
            orderInfo: undefined,
            textTip:"",
        }
    },
    mounted(){
        this._selfRechargeList()
        if(this.isCaptal=="1"){
         this.textTip = "如果您已打款至账户，财务审核后就会充值到账"
        }else{
            this.textTip = "如果您已打款至诺行账户，财务审核后就会充值到账"
        }
    },
    methods:{
        sure(){
            if(this.multipleSelection.length==0){
                // 检查是否所有订单都已开票
                const allInvoiced = this.tableData.every(item => item.billStatus === 1);
                if(allInvoiced) {
                    this.$modal.msgWarning("所有订单均已开票，无法选择")
                } else {
                    this.$modal.msgWarning("请至少选择一条未开票的订单")
                }
                return
            }
            this.$emit("orderInfo", this.orderInfo)
        },
        cancle(){
            this.$emit("close")
        },
        selectARow(val, row){
            // 如果是已开票状态，不允许选择
            if(row.billStatus === 1) {
                // 确保已开票的行不会被选中
                this.$refs.table.toggleRowSelection(row, false);
                return;
            }
            
            let selectBool = val.length && val.indexOf(row) !== -1   // 当前点击是否勾选
            
            // 更新选择列表
            if(selectBool) {  // 选中
                // 检查是否已经在选择列表中
                const exists = this.multipleSelection.some(item => item.id === row.id);
                if(!exists) {
                    this.multipleSelection.push(row);
                }
            } else {  // 取消勾选
                this.multipleSelection = this.multipleSelection.filter(item => item.id !== row.id);
            }
            
            // 重新计算总金额
            this.calculation();
        },
        handleSelectAll(val){
            // 获取所有未开票的行
            const availableRows = this.tableData.filter(row => row.billStatus !== 1);
            
            if(val.length > 0){ // 全选
                // 如果没有可选行（全部都是已开票状态），给出提示
                if(availableRows.length === 0) {
                    this.$modal.msgWarning("没有可选择的订单，所有订单均已开票")
                    return
                }
                
                // 清空当前选择
                this.multipleSelection = [];
                
                // 只添加未开票的行
                this.multipleSelection = availableRows;
            } else { // 取消全选
                this.multipleSelection = [];
            }
            
            // 重新计算总金额
            this.calculation();
        },
        calculation(){
            let money = 0
            let orderNumber = []
            let createTime = []
            this.multipleSelection.forEach(item=>{
                money = money + item.money
                orderNumber.push(item.orderNumber)
                createTime.push(item.createTime)
            })
            this.totalMoney = money
            this.orderInfo = {
                money,
                orderNumber: orderNumber.join(","),
                createTime:createTime.join(",")
            }
        },
        onPageChange(page){
			this.page = page
			this._selfRechargeList()
		},
		handleSizeChange(size){
			this.pageSize = size
			this._selfRechargeList()
        },
        _selfRechargeList(){
            let params = {
                pageNo:this.pageNo,
                pageSize:this.pageSize,
                agentId:this.agentId,
                status:1,
                rechargeType:this.rechargeType
            }
            this.tableLoading = false
            selfRechargeList(params).then(res =>{
                this.tableLoading = true
                this.tableData = res.rows
                this.total = res.total
                
                // 清除已开票项目的选择
                this.multipleSelection = this.multipleSelection.filter(item => {
                    // 保留未开票的项目
                    return item.billStatus !== 1;
                });
                
                this.$nextTick(()=>{
                    // 先清除所有选择
                    this.tableData.forEach(row => {
                        this.$refs.table.toggleRowSelection(row, false);
                    });
                    
                    // 然后只选择未开票的项目
                    this.tableData.forEach(item => {
                        if(item.billStatus !== 1) {
                            this.multipleSelection.forEach(multItem =>{
                                if(multItem.id == item.id){
                                    this.$refs.table.toggleRowSelection(item, true);
                                }
                            })
                        }
                    })
                    
                    // 重新计算总金额
                    this.calculation();
                })
            })
        },
        tableRowClassName({row, rowIndex}) {
            if (row.billStatus === 1) {
                return 'gray-row';
            }
            return '';
        },
        checkSelectable(row) {
            return row.billStatus !== 1;
        }
    },
    computed: {
    ...mapGetters(["isCaptal"]),
  },

}
</script>

<style>
.consumer .tip{line-height: 34px; padding:0 16px; color:#fff; background: #f06400; border-radius: 3px; margin-bottom:6px;}
.consumer .tip i{ font-size: 20px; position: relative;top:2px; margin-right:5px;}
.consumer_total{padding: 40px 20px; margin:20px 0; border-top:1px solid #ebebeb; border-bottom:1px solid #ebebeb;}
.el-table .gray-row {
    background-color: #f5f7fa;
    color: #909399;
    cursor: not-allowed;
}
</style>
